import React, { FC } from 'react';
import { View } from 'react-native';
import { FocusableFlatList } from '@components';

import { Theme } from '@constants';

import { getRowPosition } from './helpers';
import { CONSTANTS, fullSpacing, styles } from './styles';
import { FlatListItem, OnDemandPageLayoutProps } from './types';

import { OnDemandRow } from '../OnDemandRow';

const separator = () => <View style={{ height: fullSpacing }} />;

export const OnDemandPageLayout: FC<OnDemandPageLayoutProps> = ({
  testID,
  data = [],
  nextFocusUp,
  onLayoutFocus,
  onFocus,
}) => {
  const getItemLayout = (_: unknown, index: number) => getRowPosition(index, data);

  const renderItem = (item: FlatListItem, index: number) => (
    <OnDemandRow rowData={item} rowIndex={index} sizes={CONSTANTS} />
  );

  const keyExtractor = (_: FlatListItem, index: number) => `${index}-row`;

  return (
    <View style={styles.wrapper}>
      <FocusableFlatList
        containerStyle
        ItemSeparatorComponent={separator}
        ListFooterComponent={View}
        ListFooterComponentStyle={{
          height: Theme.appHeight,
        }}
        data={data}
        focusPositions={1}
        getItemLayout={getItemLayout}
        horizontal={false}
        initialScrollIndex={0}
        itemUnderlayColor="clear"
        keyExtractor={keyExtractor}
        listGainedFocus={onLayoutFocus}
        nestedScrollEnabled
        nextFocusLeft={null}
        nextFocusRight={null}
        nextFocusUp={nextFocusUp}
        paddingStart={CONSTANTS.topRowOffset}
        renderItem={renderItem}
        showsHorizontalScrollIndicator={false}
        testID={testID}
        wrapItem={false}
        onFocus={onFocus}
      />
    </View>
  );
};
